import { ResolveFn } from '@angular/router';
import {inject} from '@angular/core';
import {ReportsService} from '../../../services/reports.service';
import {Report} from '../classes/report';

export const reportResolver: ResolveFn<Report> = (route, state) => {
  return inject(ReportsService)
    .getReportByServiceUrl(state.url.split('/').pop() as string);
};
